import { copyText } from '@sgcmpteltd/uikit-next/utils/navigator';
import { Menu as BaseMenu, MenuItem } from '@sgcmpteltd/uikit-react';

import { createShareLinkUrl } from '@/utils/url/social-media/whats-app';

import styles from './styles.module.scss';
import type { Component } from './types';

export const Menu: Component = ({
  link,
}) => (
  <div
    className={styles.containerRoot}>
    <BaseMenu>
      <MenuItem>
        <a
          className={styles.containerShareLink}
          href={`${createShareLinkUrl({
            text: link,
          })}`}
          rel="noreferrer noopener">
          WhatsApp
        </a>
      </MenuItem>
      <MenuItem
        onClick={() => {
          copyText(link);

          // eslint-disable-next-line no-alert
          window.alert('Link copied to clipboard');
        }}>
        Copy Link
      </MenuItem>
    </BaseMenu>
  </div>

);
